import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  useSidebar,
} from "@repo/web-ui/components/base/sidebar";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@repo/web-ui/components/base/collapsible";
import {
    BookOpen,
  Cone,
  GraduationCap,
  Hand,
  Minus,
  PersonStanding,
  Plus,
  Rocket,
  Settings2,
} from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import { getLocalStoreItem, setLocalStoreItem, useLocalStore } from "../../utils/localStore";

interface Props {
  handleNavigationClick: (href: string) => void
}
const NavResources = ({ handleNavigationClick }:Props) => {
  const router = useRouter()
  const pathname = usePathname()
  const { state } = useSidebar()
  const { values, setValues } = useLocalStore()
  
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Resources</SidebarGroupLabel>
      <SidebarMenu>

        <SidebarMenuItem>
          <SidebarMenuButton 
            tooltip={"Common Grips"} 
            data-active={pathname === '/common-grips' ? "true" : "false"}
            onClick={() => handleNavigationClick('/common-grips')}
          >
            <Hand />
            <span>Common grips</span>
          </SidebarMenuButton>
        </SidebarMenuItem>

        {/* Training Guides */}
        <Collapsible asChild 
          className="group/collapsible"
          onOpenChange={(open) => setValues ? setValues(prev => ({...prev, NAV_MENU_STATE: {...prev.NAV_MENU_STATE, ['training-guides-expanded']: open}})) : {}}
          defaultOpen={values.NAV_MENU_STATE? values.NAV_MENU_STATE['training-guides-expanded'] ?? false : false}
        >
          <SidebarMenuItem>
            <CollapsibleTrigger asChild >
              <SidebarMenuButton tooltip={"Training guides"}
                data-active={state === 'collapsed' && pathname.includes('/training-guides/') ? "true" : pathname === '/training-guides' ? 'true' : "false"}
                onClick={(e) => {
                  if (state === 'collapsed') {
                    handleNavigationClick('/training-guides')
                  }
                }}
              >
                <BookOpen />
                <span>Training guides</span>
                <div className="relative ml-auto h-full">
                  <Plus className="absolute right-0 top-0 bottom-0 size-4 transition group-data-[state=open]/collapsible:opacity-0 group-data-[state=open]/collapsible:rotate-90" />
                  <Minus className="absolute right-0 top-0 bottom-0 size-4 transition group-data-[state=closed]/collapsible:opacity-0 group-data-[state=closed]/collapsible:-rotate-90" />
                </div>
              </SidebarMenuButton>
            </CollapsibleTrigger>
            <CollapsibleContent>
              <SidebarMenuSub>
                

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/training-guides/getting-started' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/training-guides/getting-started')}
                  >
                    <a href={"#"}>
                      <span>Getting started</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/training-guides/in-season' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/training-guides/in-season')}
                  >
                    <a href={"#"}>
                      <span>Pitchers (in-season)</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/training-guides/off-season' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/training-guides/off-season')}
                  >
                    <a href={"#"}>
                      <span>Pitchers (off-season)</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/training-guides/position-players' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/training-guides/position-players')}
                  >
                    <a href={"#"}>
                      <span>Position players</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/training-guides/volume-chart' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/training-guides/volume-chart')}
                  >
                    <a href={"#"}>
                      <span>Throw volume chart</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

              </SidebarMenuSub>
            </CollapsibleContent>
          </SidebarMenuItem>
        </Collapsible>

        {/* Learning pitch metrics */}
        {/* TODO(Add back learning pitch metrics section) */}
        {/* <Collapsible asChild 
          className="group/collapsible"
          onOpenChange={(open) => setValues ? setValues(prev => ({...prev, NAV_MENU_STATE: {...prev.NAV_MENU_STATE, ['learn-expanded']: open}})) : {}}
          defaultOpen={values.NAV_MENU_STATE? values.NAV_MENU_STATE['learn-expanded'] ?? false : false}
        >
          <SidebarMenuItem>
            <CollapsibleTrigger asChild >
              <SidebarMenuButton tooltip={"Learning pitch metrics"}
                data-active={state === 'collapsed' && pathname.includes('/learn/') ? "true" : pathname === '/learn' ? 'true' : "false"}
                onClick={(e) => {
                  if (state === 'collapsed') {
                    handleNavigationClick('/learn')
                  }
                }}
              >
                <GraduationCap />
                <span>Learning pitch metrics</span>
                <div className="relative ml-auto h-full">
                  <Plus className="absolute right-0 top-0 bottom-0 size-4 transition group-data-[state=open]/collapsible:opacity-0 group-data-[state=open]/collapsible:rotate-90" />
                  <Minus className="absolute right-0 top-0 bottom-0 size-4 transition group-data-[state=closed]/collapsible:opacity-0 group-data-[state=closed]/collapsible:-rotate-90" />
                </div>
              </SidebarMenuButton>
            </CollapsibleTrigger>
            <CollapsibleContent>
              <SidebarMenuSub>
                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/learn/velocity' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/learn/velocity')}
                  >
                    <a href={"#"}>
                      <span>Velocity</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/learn/spinrate' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/learn/spinrate')}
                  >
                    <a href={"#"}>
                      <span>Spinrate</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/learn/spin-tilt' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/learn/spin-tilt')}
                  >
                    <a href={"#"}>
                      <span>Spin tilt</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/learn/gyro' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/learn/gyro')}
                  >
                    <a href={"#"}>
                      <span>Gyro</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/learn/induced-movement' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/learn/induced-movement')}
                  >
                    <a href={"#"}>
                      <span>Induced movement</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

                <SidebarMenuSubItem>
                  <SidebarMenuSubButton asChild
                    data-active={pathname === '/learn/seam-shifted-wake' ? "true" : "false"}
                    onClick={() => handleNavigationClick('/learn/seam-shifted-wake')}
                  >
                    <a href={"#"}>
                      <span>Seam-shifted wake</span>
                    </a>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>

              </SidebarMenuSub>
            </CollapsibleContent>
          </SidebarMenuItem>
        </Collapsible> */}

      </SidebarMenu>
    </SidebarGroup>
  );
};

export default NavResources;
